module.exports = __webpack_public_path__ + "img/head.e60e5764.jpeg";